import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Grid, Icon } from 'semantic-ui-react';
import {  ModulesFilter, VALIDATION_PATTERNS, PRODUCT_PERMISSIONS, USER_PERMISSIONS } from 'dyl-components';

import {
    KEY_CREATED_ON, KEY_OWNER, KEY_LAST_MODIFIED,
    KEY_CONVERT, KEY_ACCOUNT,
    KEY_ACTIONS, KEY_CONTACT_NAME,
    KEY_CO_OWNER
} from './constants';
import ContactBulkActionsModal from 'shared/modals/ContactBulkActionsModal';
import { BulkActionsContext } from 'shared/context/BulkActionsProvider';
import RestrictedView from 'shared/RestrictedView';

const COLUMN_ROWS = [
    [
        { value: KEY_CREATED_ON, label: "Created" },
        { value: KEY_OWNER, label: "Owned By" }
    ],
    [
        { value: KEY_LAST_MODIFIED, label: "Last Modified" },
        { value: KEY_CO_OWNER, label: "Co-Owned By" }

    ],
    [
        { value: KEY_CONVERT, label: "Convert" },
        { value: KEY_CONTACT_NAME, label: "Contact Name", isForcedChecked: true }
    ],
    [
        { value: KEY_ACTIONS, label: "Actions" },
        { value: KEY_ACCOUNT, label: "Account" }

    ]
];

const ContactsToolbar = ({ search, onSearchSubmit, cancelFunction, onChangeSearch, isColumnHidden, onToggleColumn, onOpenAddContactModal, refresh }) => {
    const [selectedContacts,,areContactsInAllPagesSelected,] = useContext(BulkActionsContext);

    const { isReadingContacts, count, isReadingRecordsLimits } = useSelector(state => ({
        isReadingContacts: state.contacts.isReadingContacts,
        count: state.contacts.count,
        isReadingRecordsLimits: state.contact.isReadingRecordsLimits,

    }));

    const hasSelectedContacts = selectedContacts.length || areContactsInAllPagesSelected;
    const numberOfSelectedContacts = areContactsInAllPagesSelected ? count : selectedContacts.length;

    const [isBulkActionsModalOpen, setIsBulkActionsModalOpen] = useState(false);

    const onOpenBulkActionsModal = () => {
        setIsBulkActionsModalOpen(true);
    }

    const onCloseBulkActionsModal = () => {
        setIsBulkActionsModalOpen(false);
    }
    return (
        <React.Fragment>
            <Grid>
                <Grid.Row columns='equal' verticalAlign='middle'>
                    <Grid.Column width={5}>
                        <ModulesFilter
                            isLoading={isReadingContacts}
                            search={search}
                            onSearchSubmit={onSearchSubmit}
                            cancelFunction={cancelFunction}
                            onChangeSearch={onChangeSearch}
                            columnRows={COLUMN_ROWS}
                            columnCount={2}
                            isColumnHidden={isColumnHidden}
                            onToggleColumn={onToggleColumn}
                            validationPattern={VALIDATION_PATTERNS.alphanumeric_w_special_chars_for_universal_search}                            
                        />
                    </Grid.Column>
                    <Grid.Column></Grid.Column>
                    <Grid.Column width={3} floated='right'>
                        <Button floated='right' className='ContactsToolbar__NewContactsButton' disabled={!hasSelectedContacts} onClick={onOpenBulkActionsModal}>
                            Bulk Action
                        </Button>
                    </Grid.Column>
                    <Grid.Column width={2} floated='right'>
                        <RestrictedView type="disabled" productPermission={PRODUCT_PERMISSIONS.RECORDS} userPermission={USER_PERMISSIONS.CONTACTS_ADD}>
                            <Button floated='right' disabled={isReadingRecordsLimits} className='ContactsToolbar__NewContactsButton' onClick={onOpenAddContactModal}>
                                <Icon name='plus' /> New Contact
                            </Button>
                        </RestrictedView>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <ContactBulkActionsModal
                open={isBulkActionsModalOpen}
                onClose={onCloseBulkActionsModal}
                numberSelectedContacts={numberOfSelectedContacts}
                refresh={refresh}
            />
        </React.Fragment>

    )
}

export default ContactsToolbar;
